<template lang="pug">
  .establishment-selector-preview
    .selected-establishment(v-if="establishment")
      h3.name {{ establishment._name || 'Fiche sans nom' }}
      .thumbnail
        img(:src="`data:image/png;base64, ${establishment.thumbnails || fallbackThumbnail}`")
      .address(v-if="address")
        .detail {{ address.value }}
        span.city {{ address.city }},
        span.zip  {{ address.zip }}
    .empty-choice(v-else) Sélectionnez un établissement de la liste.
</template>

<script>
export default {
  props: {
    establishment: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fallbackThumbnail: '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAsNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ3/wQARCAB4ALQDABEAAREAAhEA/8QAUwABAAMBAAMAAAAAAAAAAAAAAAMEBQECBgcQAQACAQIBBgoIBwEAAAAAAAABAgMREgQhMTJCUmETIjRBUWJygqHwFBUjcYGRkqIzQ1NzssHC8f/aAAwDAAABAAIAAD8A+uOOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKmTi8OOdus3v2aRu5fR6ARfSsvPHCZtPn1QdrxuPXbkrfDb16zoC9ExMRMTExPNMaTGnpiQdAAAAAAAAAAAAAAAAABm5b34jJPD4Z20r/GyR8a1n4etbXqxYFvFgx4Y0pWO+3Wn59EeKCcHhelL1nfWtq+t88gMWmeMGW/gd9+GiY3eeK8vSp+PR7YNysxaItE6xMaxIOgAAAAAAAAAAAAAAAg4jJ4LDkv54rO32p5K/GQQYK+A4bfprbZOW3fO3dHL93ICh9YZuxj/AHAqR4XLk313Ta1t26NYiLa66zbmrEd/RrALuXPfPHg4vWMdY+2yxExSfjrt15Kx0stgXeFrivw81rTSlptW27ltbSelbvmOXTq9UHOCmYrkw25Zw3msezMzp8Yn8wXwAAAAAAAAAAAAAAAUeP8AJ7e1XX7t3/gJsnk9/wCzb8tgPWq1te0VrGsz86/dEctpnog1LWtxExw3DeLhrEb7+aYj0+rr717Ao5rRFpxUn7OlpiNOvaI0te0+eddYr1a16INjgPJ/fuDmDyvivc/MGgAAAAAAAAAAAAAAACLNj8LivTtVkFXh7xl4e2O07bUrbFfXniNJrFuXu/dEgzaY5vM4ME6x/Nzac8a9H2O7pXt0gXbcHk02Y8sUx9mN2tvWvyxumfR0a18WoIfq6/8AVr+kF/HWOFwTutrt3WmdNNder/qoI+CrbZfLbpZr7/d18X57OgL4AAAAAAAAAAAAAAAAMvi+GvO7Lh11tGmWkdeO6PPPajrf5BJwuXh4pGOk7L9at9ItNvx5Lf8APZBoAhyZsWKNb3rHdz2/SCjpk4y0Tas04as6xWelk757u/o16vjA1IjSNI5o00jzcnNAAAAAAAAAAAAAAAAAAAIMnD4cvTpHtR0gVvoGLt5o7t4JcfB4Mc67N0+m87gWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/2Q==',
    }
  },
  computed: {
    address() {
      const parent = this.establishment.group_info || this.establishment.location;
      return parent.address;
    }
  },
}
</script>

<style lang="scss">
  .establishment-selector-preview {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    .thumbnail {
      margin-bottom: 1em;
      img {
        height: 8em;
      }
    }
    .selected-establishment {
      background: white;
      box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
      border-radius: 8px;
      padding: 1em 1em 3em 1em;
      margin: 2em 0;
      width: 240px;
    }
    .empty-choice {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-style: italic;
      color: #6C6C6C;
    }
  }
</style>